/**
 * Route for `chartboost-integration`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { ChartboostIntegrationPage } from "../features/chartboost-integration/ChartboostIntegrationPage";

export const chartboostIntegrationRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/chartboost-integration",
	component: ChartboostIntegrationPage,
});

export default chartboostIntegrationRoute;
